import { isObject, isArray, has } from 'lodash';
import { DISABLED_COLUMNS } from '../../../constants';

const matrixColumnsMixin = {

    computed: {
        disabledColumns()
        {
            if (isObject(this.answer) && has(this.answer.answer, DISABLED_COLUMNS))
            {
                return this.answer.answer[DISABLED_COLUMNS];
            }
            if (isObject(this.$parent.answer) && has(this.$parent.answer.answer, DISABLED_COLUMNS))
            {
                return this.$parent.answer.answer[DISABLED_COLUMNS];
            }
            return [];
        },
    },

    methods: {

        isColumnDisabled(col)
        {
            if (isArray(this.disabledColumns))
            {
                return this.disabledColumns.indexOf(col) >= 0
            }
            return false;
        },

    }

};

export { matrixColumnsMixin }



// WEBPACK FOOTER //
// ./resources/assets/js/components/vue/mixins/matrix-columns-mixin.js